An array of email addresses for the person.

The email addresses are ordered in descending preference.

A maximum of 5 email addresses may be provided.
